import React from "react";
import { Link } from "react-router-dom";
import useUserRole, {
  isAdminRole,
  isManagerRole,
  isSuperRole,
  normalizeRole,
} from "../../hooks/useUserRole";
import useRolePermissions from "../../hooks/useRolePermissions";
import "./AdminPortalHome.css";

export default function AdminPortalHome() {
  const { role, loading } = useUserRole();
  const { can, loading: permsLoading } = useRolePermissions(role);

  if (loading || permsLoading) return <div className="adminWrap">Loading…</div>;

  const normalizedRole = normalizeRole(role);
  const isSupervisor = normalizedRole === "supervisor";
  const isManager = isManagerRole(role);
  const isAdmin = isAdminRole(role);

  const portalTitle =
    isSupervisor || isManager ? "Operations Portal" : "Admin Portal";

  const canSeeAdminPortal =
    can("FullScheduleRead") ||
    can("DailyOps") ||
    can("ApplicationsRead") ||
    can("EmployeesRead") ||
    can("EditPunches") ||
    can("TimeCardsRead") ||
    can("PayRates") ||
    can("TournamentDates") ||
    can("ScheduleControl") ||
    can("PermissionsEdit") ||
    can("DispatchAccess") ||
    can("HQAccess");

  if (!canSeeAdminPortal) {
    return (
      <div className="adminWrap">
        <h1>Admin Portal</h1>
        <p>You do not have access to this portal.</p>
        <Link to="/dashboard" className="btn btn-secondary">
          Return to Dashboard
        </Link>
      </div>
    );
  }

  return (
    <div className="adminWrap">
      <div className="adminHeader">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h1>{portalTitle}</h1>
            <div className="adminRole">
              Signed in role: <strong>{role}</strong>
              {isSupervisor && (
                <span> • Schedule pages are view-only except Daily Ops</span>
              )}
              {isManager && <span> • Operations access</span>}
            </div>
          </div>

          <Link to="/dashboard" className="btn btn-secondary">
            Return to Dashboard
          </Link>
        </div>
      </div>

      <div className="adminModuleGrid">
        {can("FullScheduleRead") && (
          <Link to="/admin/schedule" className="adminModuleCard">
            <div className="adminModuleTitle">Schedule</div>
            <div className="adminModuleHint">
              Schedule, employee weekly view, daily operations, and time off
              requests
            </div>
          </Link>
        )}

        {(can("TimeCardsRead") || can("EditPunches") || can("PayRates")) && (
          <Link to="/admin/payroll" className="adminModuleCard">
            <div className="adminModuleTitle">Payroll</div>
            <div className="adminModuleHint">
              Payroll summary, time cards, punch corrections, and pay rates •
              Manage
            </div>
          </Link>
        )}

        {(can("EmployeesRead") || can("ApplicationsRead")) && (
          <Link to="/admin/employees" className="adminModuleCard">
            <div className="adminModuleTitle">Employees</div>
            <div className="adminModuleHint">
              Staff list, roles, applications, and applicant activation
            </div>
          </Link>
        )}

        {can("ScheduleControl") && (
          <Link to="/admin/system-controls" className="adminModuleCard">
            <div className="adminModuleTitle">System Controls</div>
            <div className="adminModuleHint">
              Schedule lock, punch clock lock, pay rates, permissions, and
              tournament dates • Manage
            </div>
          </Link>
        )}

        {(can("DailyOps") || can("DispatchAccess") || can("HQAccess")) && (
          <Link to="/field-access" className="adminModuleCard">
            <div className="adminModuleTitle">Field Access</div>
            <div className="adminModuleHint">
              Command, Dispatch, HQ, and Responder PIN access
            </div>
          </Link>
        )}

       {isSuperRole(role) && (
  <Link to="/admin/assets" className="adminModuleCard">
    <div className="adminModuleTitle">Asset Management</div>

    <div className="adminModuleHint">
      Inventory, kits, carts, tents, supplies, and
      equipment tracking
    </div>
  </Link>
)}
      </div>
    </div>
  );
}